(() => {
  const selector = '#shopify-block-AcnlCdk4yTG5OL1ZNO__forms_inline_fwUQ46';
  const vars = {
    '--forms-base-font-size': '16px',
    '--forms-heading-font-size': '24px',
    '--forms-body-font': 'normal 400 16px "nexa-text", sans-serif',
    '--forms-heading-font': 'italic 700 28px "korolev", sans-serif',
    '--forms-accent-color': '#70D44B',
    '--forms-accent-color-hovered-modifier': 'rgba(112, 212, 75, 0.15)',
    '--form-background-color': '#FFFFFF',
    '--form-text-color': '#4B5563',
    '--form-placeholder-color': 'rgba(75, 85, 99, 0.6)',
    '--form-field-border': '0 0 0 1px #D1D5DB',
    '--form-field-border-focused': '0 0 0 1px #70D44B',
    '--form-field-border-radius': '12px',
    '--button-border-radius': '2px',
    '--button-text-color': '#FFFFFF',
    '--button-background-color': '#244C1B',
    '--button-background-color-hovered-modifier': 'rgba(112, 212, 75, 0.25)',
    '--container-border-radius': '16px',
    '--container-shadow': '0 0 40px 0 rgba(112, 212, 75, 0.12)',
    '--container-max-w': '783px',
    '--inline-container-max-width': '783px',
    '--inline-form-alignment': 'flex-start',
    '--forms-padding-top': '40px',
    '--forms-padding-right': '40px',
    '--forms-padding-bottom': '40px',
    '--forms-padding-left': '40px'
  };

  const applyVars = () => {
    const root = document.querySelector(selector);
    if (!root) return false;

    const targets = root.querySelectorAll('#app-embed, [data-form-root="true"]');
    if (!targets.length) return false;

    targets.forEach((target) => {
      Object.entries(vars).forEach(([key, value]) => {
        target.style.setProperty(key, value);
      });
    });

    return true;
  };

  const waitForEmbed = () => {
    const maxAttempts = 60;
    let attempts = 0;

    const tick = () => {
      attempts += 1;
      if (applyVars()) return;
      if (attempts < maxAttempts) {
        requestAnimationFrame(tick);
      }
    };

    tick();
  };

  const observer = new MutationObserver(() => {
    applyVars();
  });

  const observeRoot = () => {
    const root = document.querySelector(selector);
    if (!root) return;
    observer.observe(root, { childList: true, subtree: true });
  };

  waitForEmbed();
  observeRoot();
})();
